import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import Dropdown from "./../../elements/Dropdown";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as UploadIcon } from "../../assets/icons/upload.svg";

const UploadTBModal = ({
  handleClose,
  setUploadTBModal,
}) => {
  const redirectTo = (link) => {
    window.location.href = link;
  };

  return (
    <Modal
      title="Upload Trial Balance"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={() => {
            setUploadTBModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setUploadTBModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Proceed"
            onClick={() => {
              redirectTo("/myfinv2/book-closure/tb");
            }}
          />
        </>
      }
    >
      <div className={commoncss.pd1530} style={{"justify-self": "center"}}>
        <div class={bookclosurecss.uploadArea} style={{"text-align": "-webkit-center"}}>
          <label for="file-input">
            <div className={bookclosurecss.addTBCardDescription}>Drag and drop your file here or</div>
            <Button
            btnColor={buttoncss.secondary}
            label="Upload"
            icon={<UploadIcon width={15}/>}
          />
          </label>
          <input id="file-input" type="file" />
        </div>
      </div>
    </Modal>
  );
};

export default UploadTBModal;
